<template>
    <div :class="btnClass" @click="handleClick">
		<img class="btn-icon-left" :src="require(`@/assets/img/icon_${btnConfig.type}.png`)" alt="">
		<div class="btn-txt" v-text="btnConfig.txt"></div>
		<img class="btn-icon-right" :src="require(`@/assets/img/icon_${btnConfig.type}.png`)" alt="">
	</div>
</template>

<script>
import {
} from 'vant';

export default {
	name: 'Button',
	props: {
		btnConfig: {
			type: Object,
			default() {
				return {};
			},
		},
		submit: {
			type: Function,
			default: () => {},
		},
	},
	components: {
	},
	data() {
		return {
		};
	},
	created() {
	},
	mounted() {
	},
	computed: {
		btnClass() {
			return `btn-box ${this.$props.btnConfig.type}-btn ${this.$props.btnConfig.size ? `${this.$props.btnConfig.size}-btn` : ''} hover-dom`;
		},
	},
	methods: {
		handleClick() {
			this.$emit('submit', {});
		},
	},
	watch: {
	},
};
</script>

<style scoped lang='scss'>
.btn-box {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 194px;
	height: 50px;

	.btn-txt {
		font-size: 18px;
		line-height: 18px;
		color: #FFFFFF;
		letter-spacing: 2px;
		user-select: none;
		-ms-user-select: none;
		-webkit-user-select: none;
	}

	.btn-icon-left {
		position: absolute;
		left: -9px;
		top: calc(50% - 9.5px);
		width: 18px;
		height: 19px;
	}
	.btn-icon-right {
		position: absolute;
		right: -9px;
		top: calc(50% - 9.5px);
		width: 18px;
		height: 19px;
	}
}

.green-btn {
	background-color: #389566;
}
.red-btn {
	background-color: #B53934;
}
.blue-btn {
	background-color: #3D6991;
}
.gray-btn {
	background-color: #ADAAA0;
}

.app-pc {
	.large-btn {
		width: 280px;
	}
	.max-btn {
		width: 300px;
	}
	.super-btn {
		width: 350px;
	}
}
.app-mobile {
	.btn-box {
		width: 97px;
		height: 25px;

		.btn-txt {
			font-size: 10px;
			line-height: 10px;
		}

		.btn-icon-left {
			position: absolute;
			left: -5px;
			width: 10px;
		}
		.btn-icon-right {
			position: absolute;
			right: -5px;
			width: 10px;
		}
	}

	.large-btn {
		width: 140px;
	}
	.max-btn {
		width: 160px;
	}
	.super-btn {
		width: 210px;
	}
}
</style>
